import "./AboutPage.css";
export default function AboutPage() {
  return (
    <div className="about-page">
      <div className="page-hero about-hero">
        <div className="page-hero-content">
          <div className="eyebrow" style={{justifyContent:"center"}}><div className="eline"></div><span className="etxt">Our Story</span></div>
          <h1>About BookingAlb</h1>
          <p>Albania's premier travel booking platform</p>
        </div>
      </div>
      <section className="about-story container">
        <div className="about-grid">
          <div className="about-text">
            <div className="eyebrow"><div className="eline"></div><span className="etxt">Who We Are</span></div>
            <h2>Born in Albania, <em>built for the world</em></h2>
            <p>BookingAlb was founded with one simple mission: to make Albania hidden gems accessible to travellers from around the world. We believe Albania is one of Europe last undiscovered treasures.</p>
            <p>From the turquoise waters of the Albanian Riviera to the Ottoman-era streets of Berat and Gjirokastra, our country offers experiences that are truly unique.</p>
            <p>Our team of local experts handpicks every property on our platform, ensuring that each stay offers authentic quality and genuine Albanian hospitality.</p>
          </div>
          <div className="about-img-wrap">
            <img src="https://images.unsplash.com/photo-1555993539-1732b0258235?w=700" alt="Albania" className="about-img" />
          </div>
        </div>
      </section>
      <section className="about-values">
        <div className="container">
          <div className="eyebrow"><div className="eline"></div><span className="etxt">What We Stand For</span></div>
          <h2 className="section-title">Our Values</h2>
          <div className="values-grid">
            <div className="value-card"><div className="value-num">01</div><h3>Authenticity</h3><p>We celebrate genuine Albanian culture, food, architecture and hospitality in every property we feature.</p></div>
            <div className="value-card"><div className="value-num">02</div><h3>Quality</h3><p>Every listing is personally vetted by our team. If it does not meet our standards, it does not make it onto the platform.</p></div>
            <div className="value-card"><div className="value-num">03</div><h3>Community</h3><p>We work directly with local property owners, keeping money in Albanian communities and supporting sustainable tourism.</p></div>
          </div>
        </div>
      </section>
    </div>
  );
}
